export default "public/info-circle-blue.svg";